import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Intro extends React.PureComponent {
    static propTypes = {
        handleMaskHide: PropTypes.func,
        introNum: PropTypes.number
    };

    introInfo = [
        {
            title: '新增本土确诊数据说明',
            text: '该数据来自国家卫健委公布的31省（自治区、直辖市）新增本土确诊病例，不包括港澳台确诊病例。因国家卫健委每日早晨公布的新增数据为前一日0-24小时新增数据，且各省、市卫健委公布时间及方式各不相同，该数据较各省、市卫健委发布的新增数据可能有一定的时间延迟。'
        },
        {
            title: '新增确诊数据说明',
            text: '该数据来自国家卫健委公布的31省（自治区、直辖市）新增确诊病例（包括境外输入确诊），及港澳台新增确诊病例。因国家卫健委每日早晨公布的新增数据为前一日0-24小时新增数据，且各省、市卫健委公布时间及方式各不相同，该数据较各省、市卫健委发布的新增数据可能有一定的时间延迟。'
        },
        {
            title: '本土现有确诊数据说明',
            text: '本土现有确诊是指尚在治疗中的本土确诊病例，每天会根据国家卫健委和各省卫健委发布的最新数据更新。'
        },
        {
            title: '无症状感染者说明',
            text: '无症状感染者是指无相关临床症状（如发热、咳嗽、咽痛等），但呼吸道等标本核酸检测或抗体检测呈阳性者。'
        },
        {
            title: '现有确诊数据说明',
            text: '现有确诊为存量数据，计算方法为：累计确诊数-累计死亡数-累计治愈数。||广东、四川下辖市（州）现有确诊数中，包含境外输入现有确诊病例数。'
        },
    ]

    render() {
        const { handleMaskHide, introNum } = this.props;
        const title = this.introInfo[introNum].title;
        const bref = this.introInfo[introNum].text.split('||');

        return (
            <div className={styles.intro}>
                <div id="close" className={styles.close} onClick={handleMaskHide} />
                <div className={styles.title}>{title}</div>
                <div className={styles.content}>
                    {bref.map((item, index) => {
                        return (
                            <div key={index} className={styles.content_p}>
                                <p>{item}</p>
                            </div>
                        );
                    })}
                    {/* <div className={styles.content_p}>
                        <div>1.国外实时数据来源</div>
                        <p>
                            国内权威媒体（如央视新闻、人民日报、环球网等），各国CDC（即疾病控制中心）官网，国外官方媒体。
                        </p>
                    </div> */}
                </div>
                {/* <div className={styles.mask} /> */}
            </div>
        );
    }
}

export default errorBoundary(Intro);
